import Vue from "vue";
import Router from "vue-router";

import Contact from "./components/Contact/Contact";
import ThxDocument from "./components/Contact/ThxDocument";
import ThxReservation from "./components/Contact/ThxReservation";
Vue.use(Router);

export default new Router({
    mode: "history",
    routes: [
        {
            path: "/contact",
            name: "contact",
            component: Contact
        },
        {
            path: "/contact/thxdocument",
            name: "contact-thx-document",
            component: ThxDocument
        },
        {
            path: "/contact/thxreservation",
            name: "contact-thx-reservation",
            component: ThxReservation
        }
    ]
});
